import { Descendant } from 'slate';
import { DocumentTranscriptTextV1 } from '@utils/types/editors/transcripts/transcript.ts';

// #2237 — word-timing fallback decision.
// A translated word without `start`/`stop` returns `false` here: no
// per-word highlight, and no fallback to the source utterance's
// timings. Rationale: translations don't line up word-for-word with
// the original, so lending them source timings would mislead the
// reader (highlight marches ahead of the word being spoken). The
// utterance-level row stays visible via playback scroll; mis-aligned
// per-word colour is worse than none. If we later get real word
// timings on translations, this guard becomes a no-op and the
// highlight turns on automatically.
export const currentWordIsSeeking = (
  child: Descendant & DocumentTranscriptTextV1,
  currentTime: number
): boolean => {
  const seekingValueInSec = currentTime ? currentTime * 1000 : null;
  if (!seekingValueInSec || !child.start || !child.stop) return false;

  // Add 50ms shift to make the blue highlight appear earlier
  const shiftedSeekingValue = seekingValueInSec + 50;

  return (
    shiftedSeekingValue >= child.start && shiftedSeekingValue <= child.stop
  );
};
